import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-br from-[#FFF4E6] to-[#FAFAF8]">
        <div className="container-custom">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#1A1A1A] mb-4">
              Privacy Policy
            </h1>
            <p className="text-[#6B7280]">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto prose prose-gray">
            
            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Introduction</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                TekClap is a United States-based technology consulting and services provider. We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or engage with our services.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Information We Collect</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">We may collect the following types of information:</p>
              <ul className="list-disc pl-6 text-[#6B7280] space-y-2">
                <li><strong>Contact Form Submissions:</strong> Name, company, email address, phone number, role, and any message content you provide through our contact forms.</li>
                <li><strong>Business Inquiries:</strong> Information related to service inquiries, consultation requests, and business communications.</li>
                <li><strong>Website Analytics and Cookies:</strong> We may collect information about your browsing behavior, device information, IP address, and interactions with our website through cookies and similar technologies.</li>
              </ul>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">How We Use Your Information</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">We use the information we collect to:</p>
              <ul className="list-disc pl-6 text-[#6B7280] space-y-2">
                <li>Respond to your inquiries and communicate with you about our services</li>
                <li>Process and manage service requests and consultations</li>
                <li>Improve our website, services, and user experience</li>
                <li>Send relevant business communications (with your consent where required)</li>
                <li>Comply with legal obligations and protect our rights</li>
              </ul>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Data Sharing</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                We do not sell your personal data to third parties. We may share your information with:
              </p>
              <ul className="list-disc pl-6 text-[#6B7280] space-y-2">
                <li>Service providers who assist us in operating our website and delivering services</li>
                <li>Professional advisors as necessary for business operations</li>
                <li>Legal authorities when required by law or to protect our rights</li>
              </ul>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Data Retention and Security</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                We retain your personal information only for as long as necessary to fulfill the purposes outlined in this policy or as required by law. We implement appropriate technical and organizational security measures to protect your information against unauthorized access, alteration, disclosure, or destruction.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Your Rights</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">You have the right to:</p>
              <ul className="list-disc pl-6 text-[#6B7280] space-y-2">
                <li>Request access to the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your personal information (subject to legal requirements)</li>
                <li>Opt out of marketing communications</li>
              </ul>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Cookies</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                Our website uses cookies and similar tracking technologies to enhance your browsing experience. You can control cookie preferences through your browser settings.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Contact Us</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                For privacy-related inquiries or to exercise your rights, please contact us at:
              </p>
              <p className="text-[#6B7280]">
                <strong>Email:</strong> <a href="mailto:info@tekclap.com" className="text-[#F58B23] hover:underline">info@tekclap.com</a>
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Changes to This Policy</h2>
              <p className="text-[#6B7280] leading-relaxed">
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date. We encourage you to review this policy periodically.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
